import React, { useState } from 'react';

import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/home.js';
import About from './pages/about.js';
import Human from './pages/human.js';
import Animal from './pages/animal.js';
import Media from './pages/media.js';
import Product from './pages/product.js';

import './App.css';

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/human" element={<Human />} />
        <Route path="/animal" element={<Animal />} />
        <Route path="/media" element={<Media />} />
        <Route path="/human/product/:slug" element={<Product />} />
        <Route path="/animal/product/:slug" element={<Product />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Header />

        <main className="flex-grow bg-white">
          <AnimatedRoutes />
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
